import React from 'react';
import tw from 'twin.macro';
import { format } from '@teetsh/app/src/utils/time/format';

interface Props {
  start: Date;
  end: Date;
  className?: string;
}

export function HoraireComponent(props: Props) {
  const { start, end, className = '' } = props;

  // TODO use localized time format to support AM/PM?
  const horaireLabel = `${format(start, 'fr-FR', 'HH:mm')} - ${format(
    end,
    'fr-FR',
    'HH:mm',
  )}`;

  return (
    <div
      css={[tw`text-sm font-semibold bg-transparent text-neutral-intense`]}
      className={className}
    >
      {horaireLabel}
    </div>
  );
}
